import React from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';

interface AreaStepProps {
  value: {
    area: number;
  };
  onChange: (field: string, value: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const AreaStep: React.FC<AreaStepProps> = ({
  value,
  onChange,
  onNext,
  onBack
}) => {
  const handleAreaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(e.target.value) || 0;
    onChange('area', newValue);
  };

  return (
    <div className="space-y-6">
      {/* Boutons de navigation compacts en haut */}
      <div className="flex justify-between items-center pb-4 border-b border-neutral-200">
        <h2 className="text-base font-semibold text-primary">Surface du bien</h2>
        <div className="flex items-center gap-2 ml-4">
          {onBack && (
            <button
              type="button"
              onClick={onBack}
              className="px-3 py-2 text-sm font-medium text-neutral-700 bg-white border border-neutral-300 rounded-lg hover:bg-neutral-50 transition-colors flex items-center gap-1"
            >
              <ArrowLeft className="h-4 w-4" />
              Précédent
            </button>
          )}
          <button
            type="button"
            onClick={onNext}
            disabled={!value.area || value.area <= 0}
            className={`px-3 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary-dark transition-colors flex items-center gap-1 ${
              !value.area || value.area <= 0 ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            Suivant
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>
      
      <div>
        <label htmlFor="area" className="block text-sm font-medium text-neutral-700 mb-2">
          Surface en m²
        </label>
        <div className="flex items-center space-x-2">
          <input
            type="number"
            id="area"
            value={value.area || ''}
            onChange={handleAreaChange}
            min="0"
            step="0.5"
            className="input w-full"
            placeholder="Entrez la surface"
          />
          <span className="text-neutral-500">m²</span>
        </div>
      </div>
    </div>
  );
};

export default AreaStep;